/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useState, useEffect, forwardRef } from 'react'
import prop from 'ramda/src/prop'
import addIndex from 'ramda/src/addIndex'
import map from 'ramda/src/map'
import findIndex from 'ramda/src/findIndex'
import propEq from 'ramda/src/propEq'
import slice from 'ramda/src/slice'
import length from 'ramda/src/length'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import useAsyncSelect from 'root/src/client/web/hooks/useAsyncSelect'
import Tapable from 'react-tappable'
import Close from '@material-ui/icons/Close'
import LoadingButton from 'root/src/client/web/base/LoadingButton'
import { FieldActionButton } from 'root/src/client/web/form/TextFields/MuiStyledTextField'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FieldError } from 'root/src/client/web/form/FieldError'
import Input from './Input'
import Chip from './Chip'
import Value from './Value'
import LoadingBubbles from './LoadingBubbles'
import OptionComponent from './OptionComponent'
import style from './style'
import onOutsideClickHandler from './onOutsideClickHandler'

const LoadMoreButton = ({ loading, handleLoadMore }) => (
	<LoadingButton
		isLoading={loading}
		type="button"
		onClick={handleLoadMore}
		buttonType="loadMoreButton"
	>
		+ Load More
	</LoadingButton>
)
const MenuComponent = ({
	Menu, Options, textInput, listOpen, hasMore, classes, ...props
}) => (Menu ? (
	<Menu>{Options}
		{textInput !== '' && listOpen && hasMore && (
			<LoadMoreButton {...props} />
		)}
	</Menu>
)
	: (
		<ul className={classes.ddList}>{Options}
			{textInput !== '' && listOpen && hasMore && (
				<LoadMoreButton {...props} />
			)}
		</ul>
	))

const AsyncSelect = memo(forwardRef(({
	loadOptions, value, placeholder, onSelect, classes, inputHeight,
	isMulti, isFormStyle, textFieldProps, locked, debounceDelay, fieldActionButton,
	fieldActionButtonFn, moduleKey, moduleId, fieldId, fieldIcon, fieldTheme,
	components: {
		Menu,
		MultiValue,
		Option,
		ValueContainer,
	},
}, ref) => {
	const {
		listOpen, setListOpen,
		options, setOptions,
		loading, setLoading,
		hasMore, setHasMore,
		cursor, setCursor,
		textInput, setTextInput,

	} = useAsyncSelect()
	const [activeOption, setActiveOption] = useState(options[0])
	const arrowsHandler = (e) => {
		if (activeOption) {
			const index = findIndex(propEq('id', activeOption.id), options)
			const key = e.keyCode

			switch (key) {
			case 40:
				if (index < options.length - 1) {
					setActiveOption(options[index + 1])
					document.removeEventListener('keydown', arrowsHandler)
				}
				break
			case 38:
				if (index > 0) {
					setActiveOption(options[index - 1])
					document.removeEventListener('keydown', arrowsHandler)
				}
				break
			default:
				break
			}
		}
	}
	useEffect(() => {
		setActiveOption(options[0])
	}, [options])
	if (listOpen) {
		document.addEventListener('keydown', arrowsHandler)
	}

	const input = React.createRef()
	const error = prop('error', textFieldProps)
	const helperText = prop('helperText', textFieldProps)

	const Options = slice(0, length(options), addIndex(map)((option, index) => (
		<OptionComponent
			key={option.id}
			props={{
				Option,
				classes,
				onSelect,
				setListOpen,
				setOptions,
				isMulti,
				value,
				input,
				option,
				index,
				isActive: activeOption === option,
				activeOption,
			}}
		/>
	), options))

	const ValueContainerComponent = ValueContainer
		// eslint-disable-next-line no-unneeded-ternary
		? ValueContainer : ({ children }) => <div>{children}</div>

	const handleLoadMore = async () => {
		setLoading(true)
		const loadOptionsResult = await loadOptions(textInput, cursor)
		setLoading(false)
		setHasMore(!!loadOptionsResult[0].cursor)
		setCursor(loadOptionsResult[0].cursor)
		setOptions([...options, ...loadOptionsResult])
	}

	const inputProps = {
		input,
		fieldTheme,
		classes,
		placeholder,
		setListOpen,
		setLoading,
		setOptions,
		MultiValue,
		loadOptions,
		value,
		options,
		onSelect,
		isMulti,
		error,
		locked,
		listOpen,
		activeOption,
		debounceDelay,
		inputHeight,
		cursor,
		setCursor,
		hasMore,
		setHasMore,
		textInput,
		setTextInput,
		loading,
		handleLoadMore,
		Options,
		Menu,
	}

	return (
		<OutsideClickHandler
			onOutsideClick={() => onOutsideClickHandler(input, setListOpen)}
		>
			<div
				ref={ref}
				className={classes.ddWrapper}
			>
				<div
					className={classNames(
						classes.inputWrapper,
						error && classes.inputWrapperError,
						locked && classes.inputWrapperLocked,
					)}
					style={{
						backgroundColor: fieldTheme?.backgroundColor,
						color: fieldTheme?.textColor,
					}}
				>
					<div
						onClick={() => !locked && input.current.focus()}
						className={classNames(
							isFormStyle ? classes.formHeader : classes.ddHeader,
							locked && classes.formHeaderLocked,
						)}
						style={{
							backgroundColor: fieldTheme?.backgroundColor,
							color: fieldTheme?.textColor,
						}}
					>
						{(value && !isMulti)
							&& (
								<Chip props={{ classes,
									value,
									input,
									onSelect,
									locked,
									style: {
										backgroundColor: fieldTheme?.chipColor,
										color: fieldTheme?.textColor,
									} }}
								/>
							)}
						{isMulti
							? (
								<ValueContainerComponent hasError={error}>
									{
										(value && isMulti)
										&& (
											<Value props={{ value,
												MultiValue,
												input,
												onSelect,
												locked,
												style: {
													backgroundColor: fieldTheme?.backgroundColor,
													color: fieldTheme?.textColor,
												} }}
											/>
										)
									}
									{isMulti && <Input props={inputProps} fieldTheme={fieldTheme} />}
								</ValueContainerComponent>
							)
							: <Input props={inputProps} fieldTheme={fieldTheme} />}
					</div>
					{(prop('length', value) > 0 && !locked)
						&& <Tapable><Close onClick={() => onSelect([])} className={classes.icon} /></Tapable>
					}
					{loading && <LoadingBubbles classes={classes} />}
					{listOpen && <MenuComponent {...inputProps} />}
					{
						value && fieldActionButton && (
							<div className={classes.insideField}>
								<FieldActionButton
									label={fieldActionButton.label}
									action={fieldActionButton.action}
									actionFn={fieldActionButtonFn}
									value={value}
									fieldId={fieldId}
									moduleKey={moduleKey}
									moduleId={moduleId}
								/>
							</div>
						)
					}
					{fieldIcon
					&& (
						<div className={classes.iconWrapper}>
							<FontAwesomeIcon icon={fieldIcon} alt="fieldIcon" size="lg" />
						</div>
					)
					}
				</div>
				{error && <FieldError error={helperText} />}
			</div>
		</OutsideClickHandler>
	)
}))

export default withStyles(style, { name: 'MuiAsyncSelect' })(AsyncSelect)
